import type { ComponentProps, ReactNode } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import { TabsList } from "@volca/ui/components/ui/tabs";
import {
  getEdgeFadeStyle,
  useScrollEdges,
} from "@volca/ui/hooks/use-scroll-edges";
import { cn } from "@volca/ui/lib/utils";

export const PageTabsList = ({
  className,
  trailing,
  ...props
}: Omit<ComponentProps<typeof TabsList>, "variant"> & {
  /** Sits after the tabs, outside the tab list: Job Costing's More. */
  trailing?: ReactNode;
}) => {
  const { setNode, edges } = useScrollEdges(true, "x");
  return (
    <Stack className="relative w-full min-w-0 flex-none before:pointer-events-none before:absolute before:inset-x-0 before:bottom-0 before:border-b before:border-dashed before:border-line">
      <Stack
        direction="row"
        align="center"
        gap={trailing ? 4 : 0}
        className="w-full min-w-0"
      >
        <Stack
          ref={setNode}
          style={getEdgeFadeStyle(edges)}
          className={cn(
            "scrollbar-hidden min-w-0 overflow-x-auto overflow-y-hidden",
            { "w-full": !trailing },
          )}
          onFocus={(event) => {
            const strip = event.currentTarget;
            const bounds = strip.getBoundingClientRect();
            const tab = event.target.getBoundingClientRect();
            if (tab.left < bounds.left)
              strip.scrollLeft += tab.left - bounds.left;
            else if (tab.right > bounds.right)
              strip.scrollLeft += tab.right - bounds.right;
          }}
        >
          <TabsList
            variant="line"
            className={cn(
              "justify-start gap-4 px-0 group-data-horizontal/tabs:h-10 [&>[data-slot=tabs-trigger]]:flex-none [&>[data-slot=tabs-trigger]]:border-x-0 [&>[data-slot=tabs-trigger]]:px-0",
              className,
            )}
            {...props}
          />
        </Stack>
        {trailing}
      </Stack>
    </Stack>
  );
};
